import { render, staticRenderFns } from "./TranProgramView.vue?vue&type=template&id=ecf01006&scoped=true"
import script from "./TranProgramView.vue?vue&type=script&lang=js"
export * from "./TranProgramView.vue?vue&type=script&lang=js"
import style0 from "./TranProgramView.vue?vue&type=style&index=0&id=ecf01006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf01006",
  null
  
)

export default component.exports